import React from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

export interface ExportFiltersTooltipProps {
    id: string;
    details: string;
}

const ExportFiltersTooltip: React.FC<ExportFiltersTooltipProps> = ({ id, details }) => {
    const items = details
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item !== ""); // remove any empty strings

    return (
        <Tooltip
            id={id}
            className="shadow-lg z-50 bg-white w-[200px] p-0 !opacity-100"
            style={{ backgroundColor: "white" }}
            globalCloseEvents={{ clickOutsideAnchor: true }}
            clickable
        >
            <div className="p-2 text-xs text-gray-900 space-y-1">
                {items.length === 0 ? (
                    <div>No filters applied</div>
                ) : (
                    items.map((item, i) => {
                        // Each item should look like "provider: BOOKING"
                        const [keyPart, valuePart] = item.split(":").map(str => str.trim());
                        return (
                            <div key={i}>
                                <span className="font-semibold">{keyPart}</span>
                                {valuePart !== undefined ? `: ${valuePart}` : ""}
                            </div>
                        );
                    })
                )}
            </div>
        </Tooltip>
    );
};

export default ExportFiltersTooltip;